import { render, staticRenderFns } from "./ListImport.vue?vue&type=template&id=2328a5fc&"
import script from "./ListImport.vue?vue&type=script&lang=js&"
export * from "./ListImport.vue?vue&type=script&lang=js&"
import style0 from "./ListImport.vue?vue&type=style&index=0&id=2328a5fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports